import React, { } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "@chakra-ui/react";
import "./view.css";
// Components
import MaintenanceViewMenu from "./menu/menu";
import MaintenanceViewGrid from "./grid/grid";
// Utils
import { getToastOpt } from "../../../utils/utils";

const MaintenanceView = ({ 
  primaryKey,
  primaryNameKey,
  menuConfig,
  gridConfig, 
  actions, 
  reducerName, 
  setIsLoading,
  setRefreshData,
  refreshData,
  itemNameSingular,
  itemIsMale = true,
  defaultDetailPathKey,
  page,
  onRemoved = () => {},
  allowSelection = true,
  isMultiRowSelection = false,
}) => {
  const dispatch = useDispatch();
  const toast = useToast();
  // Selectors
  const selectedRows = useSelector((state) => state[reducerName].selectedRows);

  /*
   * Delete (action)
   */
  const remove = async () => {
    if (!selectedRows || selectedRows.length === 0) return;

    setIsLoading(true);
    const selectedRowsToRemove = [...selectedRows];
    const removePromises = selectedRowsToRemove.map((row) => actions.remove(row[primaryKey]));

    Promise.all(removePromises.map((action) => dispatch(action))).then(
      () => {
        setIsLoading(false);
        dispatch(actions.setSelectedRows([]));
        toast(getToastOpt({
          title: selectedRowsToRemove.length > 1
            ? `${selectedRowsToRemove.length} registres eliminats`
            : `${itemNameSingular} ${itemIsMale ? "eliminat" : "eliminada"}`,
          status: "success",
          position: "top",
        }));
        // Raise event
        onRemoved();
      },
      (err) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Error eliminant ${itemNameSingular}`,
          description: err,
          status: "error",
        }));
      }
    );
  };

  return (
      <div id="maintenance-view">
        {menuConfig.visible !== false && (
          <MaintenanceViewMenu 
            primaryKey={primaryKey}
            primaryNameKey={primaryNameKey}
            config={menuConfig} 
            reducerName={reducerName}
            setRefreshData={setRefreshData}
            itemNameSingular={itemNameSingular}
            itemIsMale={itemIsMale}
            onDelete={remove}
            defaultDetailPathKey={defaultDetailPathKey}
            page={page}
          />
        )}
        <MaintenanceViewGrid 
          primaryKey={primaryKey}
          primaryNameKey={primaryNameKey}
          config={gridConfig} 
          actions={actions} 
          reducerName={reducerName}
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}
          defaultDetailPathKey={defaultDetailPathKey}   
          itemNameSingular={itemNameSingular}
          page={page} 
          allowSelection={allowSelection}
          isMultiRowSelection={isMultiRowSelection}
        />     
      </div>
  );
};

export default MaintenanceView;
